module.exports = __webpack_public_path__ + "static/media/schuhkurier.32fd49c4.png";